import React from 'react';
import './slider.style.scss';
import { __SliderProps } from './slider.interface';
import { connect, ConnectedProps } from 'react-redux';
import { Direction, ReduxState, TextDirection } from 'interface';

const SLPSlider: React.FC<ConnectedProps<typeof connector> & __SliderProps> = (
    props: ConnectedProps<typeof connector> & __SliderProps,
) => {
    const isReverse = (props.dir === TextDirection.ltr) !== (props.direction === Direction.ltr);
    return (
        <div
            style={{ transform: `translateX(${props.dir === TextDirection.ltr ? '-' : ''}${props.step * 100}%)` }}
            className={`ucheck-slp-slider-comp ${isReverse ? 'ltr-direction' : ''}`}
        >
            {props.children}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
});

const connector = connect(mapStateToProps);
export default connector(SLPSlider);
